import React, { useContext, useEffect, useState } from 'react'
import { CButton, CCard, CCardBody, CFormText, CModal, CModalBody, CSpinner } from '@coreui/react'
import 'overlayscrollbars/css/OverlayScrollbars.css'
import { formatFileName, isEmpty, raiseToast } from '../../views/utils/helper'
import { AppContext } from 'src/views/context/app'
import FileUploadCard from './fileUploadCard'
import { CHUNK_SIZE } from 'src/views/utils/constants'
import { getNetworkUploadSpeedApi, getPresignedPostUrl } from 'src/s3upload/upload-file'
import DeleteModal from '../DeleteModal/DeleteModal'
import CloseIcon from '../../assets/closeIcon.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWindowRestore } from '@fortawesome/free-solid-svg-icons'

const createChunks = (file) => {
  let startPointer = 0
  let endPointer = file.size
  let chunks = []
  while (startPointer < endPointer) {
    let newStartPointer = startPointer + CHUNK_SIZE
    chunks.push(file.slice(startPointer, newStartPointer))
    startPointer = newStartPointer
  }
  return chunks
}

const MultiFileUpload = () => {
  const accountId = localStorage.getItem('accountId')
  const {
    uplaodFiles,
    setUplaodFilesModal,
    setLoader,
    uplaodModalMinimize,
    setUplaodModalMinimize,
    uploadFinishCallback,
  } = useContext(AppContext)
  const [completeCount, setCompleteCount] = useState(0)
  const [failedCount, setFailedCount] = useState(0)
  const [fileCardInfo, setFileCardInfo] = useState({})
  const [formattedFileName, setFormattedFileName] = useState([])
  const [deleteModal, setDeleteModal] = useState(false)
  const [cancelAll, setCancelAll] = useState(false)
  const [uploadSpeed, setUploadSpeed] = useState({ mbps: 0, bps: 0, kbps: 0 })

  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789~!@#$%^&*()_+`-=[]{}|;':,./<>?"

  const getNetworkUploadSpeed = () => {
    const fileSizeInBytes = 250000
    const startTime = new Date().getTime()
    const defaultData = generateTestData(fileSizeInBytes / 1000)
    // const data = JSON.stringify({ data: defaultData })
    getNetworkUploadSpeedApi({ data: defaultData }).then(() => {
      const endTime = new Date().getTime()
      const duration = (endTime - startTime) / 1000
      const bitsLoaded = fileSizeInBytes * 8
      const bps = (bitsLoaded / duration).toFixed(2)
      const kbps = (bps / 1000).toFixed(2)
      const mbps = (kbps / 1000).toFixed(3)
      setUploadSpeed({ mbps, bps, kbps })
    })
  }

  const generateTestData = (sizeInKmb) => {
    const iterations = sizeInKmb * 1000 //get byte count
    let result = ''
    for (var index = 0; index < iterations; index++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length))
    }
    return result
  }

  useEffect(() => {
    const id = setInterval(() => {
      getNetworkUploadSpeed()
    }, 3000)
    return () => clearInterval(id)
  }, [])

  useEffect(() => {
    setLoader(false)
    getSignedUrl()
  }, [uplaodFiles])

  useEffect(() => {
    if (cancelAll && completeCount + failedCount === uplaodFiles.length) {
      setUplaodFilesModal(false)
    }
  }, [cancelAll, completeCount, failedCount])

  const checkSubtitle = (file) => {
    if (file.type === 'text/vtt' || file.type === 'application/x-subrip') {
      return 'SRT'
    }
    return file.type
  }

  const getSignedUrl = async () => {
    let assetData = []
    let tempFileName = []
    let tempChunksAndUrls = {}

    for (let index = 0; index < uplaodFiles.length; index++) {
      const file = uplaodFiles[index]
      const fileChunks = await createChunks(file)
      const formatedName = formatFileName(file.name)

      tempFileName.push(formatedName)

      tempChunksAndUrls[`${formatedName}`] = {}

      tempChunksAndUrls[`${formatedName}`][`chunks`] = fileChunks

      let assetObj = {
        file_name: formatedName,
        file_metadata: {
          file_size: file.size,
          file_type: file.fileType === 'other' ? checkSubtitle(file) : file.type,
        },
        file_type: file.fileType,
        num_parts: fileChunks.length,
      }

      tempChunksAndUrls[`${formatedName}`][`signedURLPayload`] = assetObj
      assetData.push(assetObj)
    }
    setFormattedFileName(tempFileName)

    const signedURLRes = await getPresignedPostUrl({
      customer_id: accountId,
      upload_type: 'FROM_DEVICE',
      assets: assetData,
    })

    if (signedURLRes?.success) {
      for (let index = 0; index < tempFileName.length; index++) {
        const fileName = tempFileName[index]
        tempChunksAndUrls[`${fileName}`][`signedURLObj`] =
          signedURLRes.data[`${fileName}`].signed_url_dict
        tempChunksAndUrls[`${fileName}`][`assetId`] = signedURLRes.data[`${fileName}`].asset_id
        tempChunksAndUrls[`${fileName}`][`s3Key`] = signedURLRes.data[`${fileName}`].s3_key
        tempChunksAndUrls[`${fileName}`][`jobId`] = signedURLRes.data[`job_id`]
      }
      setFileCardInfo(tempChunksAndUrls)
    } else {
      setUplaodFilesModal(false)
      raiseToast('error', 'Something went Wrong, Please Try-Again!')
    }
  }

  const onFileUploadComplete = () => {
    setCompleteCount((completeCount) => ++completeCount)
  }
  const handleFileUploadFailed = (value) => {
    setFailedCount((failedCount) => (failedCount += value))
  }

  const onCancelAll = () => {
    setCancelAll(true)
  }

  return (
    <>
      <CModal
        size="lg"
        // visible={true}
        visible={!cancelAll && !uplaodModalMinimize}
        style={{ display: `${uplaodModalMinimize ? 'none' : ''}` }}
        alignment="center"
        backdrop={!uplaodModalMinimize}
      >
        <CModalBody
          className="px-5 py-4 "
          style={{ display: `${uplaodModalMinimize ? 'none' : ''}` }}
        >
          <div className="position-absolute end-0 mx-3">
            {/*<img*/}
            {/*  src={MinimizeIcon}*/}
            {/*  alt="Minimize"*/}
            {/*  style={{ height: '1.5rem', width: '1.5rem', cursor: 'pointer' }}*/}
            {/*  onClick={() => setUplaodModalMinimize(true)}*/}
            {/*  className="mx-2"*/}
            {/*  title="Minimize"*/}
            {/*/>*/}
            <img
              src={CloseIcon}
              alt="CloseIcon"
              style={{ height: '1.5rem', width: '1.5rem', cursor: 'pointer' }}
              onClick={
                completeCount + failedCount === uplaodFiles.length
                  ? () => setUplaodFilesModal(false)
                  : () => setDeleteModal(true)
              }
              className="mx-2"
            />
          </div>
          <div className="d-flex justify-content-center text-center align-items-">
            <p style={{ fontSize: '1.5rem', fontWeight: '500' }} className="mx-2">
              Uploading File
            </p>
            <CFormText className="mt-2">{`${completeCount} of ${uplaodFiles?.length} Completed ${
              failedCount > 0 ? `(${failedCount} Failed)` : ''
            }`}</CFormText>
          </div>
          <div className="container scrollbar" style={{ maxHeight: '22rem' }}>
            {!isEmpty(fileCardInfo) ? (
              uplaodFiles.map((info, index) => {
                return (
                  <FileUploadCard
                    fileInfo={info}
                    uploadData={fileCardInfo[formattedFileName[index]]}
                    onComplete={onFileUploadComplete}
                    onFailed={handleFileUploadFailed}
                    key={index}
                    triggerCancel={cancelAll}
                    uploadSpeed={uploadSpeed}
                  />
                )
              })
            ) : (
              <div className="text-center mt-2" style={{ height: '7rem' }}>
                <CSpinner color="info" />
                <p>loading...</p>
              </div>
            )}
          </div>
          {!isEmpty(fileCardInfo) ? (
            <div className="d-flex justify-content-end mt-4 pt-4 px-4">
              <CButton
                className="text-white px-4"
                // onClick={buttonFunction}
                color="light"
                style={{
                  pointerEvents: 'auto',
                  backgroundColor: '#a2a4a7',
                  borderRadius: '0.7rem',
                }}
                title={'Cancel Upload'}
                onClick={
                  completeCount + failedCount === uplaodFiles.length
                    ? () => {
                        setUplaodFilesModal(false)
                        uploadFinishCallback('finished')
                      }
                    : () => setDeleteModal(true)
                }
              >
                {completeCount + failedCount === uplaodFiles.length ? 'Done' : 'Cancel'}
              </CButton>
            </div>
          ) : null}
        </CModalBody>
      </CModal>

      {uplaodModalMinimize && (
        <div className="border position-absolute end-0 bottom-0 mx-3" style={{ cursor: 'pointer' }}>
          <CCard
            className="px-"
            style={{ width: '15rem' }}
            onClick={() => setUplaodModalMinimize(false)}
          >
            <CCardBody>
              <div className="d-flex justify-content-between align-items-center">
                Uploading...
                <FontAwesomeIcon
                  icon={faWindowRestore}
                  style={{ fontSize: '1rem' }}
                  title="Maximize"
                />
              </div>
            </CCardBody>
          </CCard>
        </div>
      )}
      {deleteModal && (
        <DeleteModal
          openModal={deleteModal}
          title={`Are you sure you want to Cancel Uploading?`}
          confirmButtonText={`Yes`}
          onCancel={() => {
            setDeleteModal(false)
          }}
          onConfirm={() => {
            setDeleteModal(false)
            onCancelAll()
            uploadFinishCallback('cancelled')
          }}
        />
      )}
    </>
  )
}

export default MultiFileUpload
